import httpApi from '../api/httpApi';
import useSWR from 'swr';
import { LiveOrdersData } from '../../models/LiveOrders';

const LIVE_ORDERS = 'api/v1/bc-orders';

const useLiveOrdersSWR = () => {
    const fetchUser = (query): Promise<LiveOrdersData[]> => {
        return httpApi
            .get<{ orders: LiveOrdersData[] }>(query)
            .then((res) => {
                return res.getData().orders;
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(LIVE_ORDERS, fetchUser, {
        // dedupingInterval: 600000, // 10min
        errorRetryCount: 3,
    });

    return {
        orders: data ? data : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useLiveOrdersSWR;
